import React, { useState } from "react";
import Map, { Marker, Popup, NavigationControl } from "react-map-gl";
import markerUrl from "./location.svg";
// import moment from "moment";
import "./TrafficIndex.css";
import Axios from "axios";
import imsc from "./imsc.png";

function TrafficIndexCoords() {
  const [lat, setlat] = useState(34.0224);
  const [long, setlong] = useState(-118.2851);
  const [date, setdate] = useState("2018-03-01");
  const [time, settime] = useState("19:00");
  const [method, setmethod] = useState("Kriging Interpolation");
  const [speed, setspeed] = useState(10);
  const [mindistance, setmindistance] = useState("15 meters");
  const [avgdistance, setavgdistance] = useState("22 meters");
  const [congestion, setcongestion] = useState("Standstill");
  const handleOnClick = (event) => {
    setlat(event.lngLat.lat);
    setlong(event.lngLat.lng);
    Axios.post("/api/traffic/estimate/coords/", {
      Latitude: lat,
      Longitude: long,
      Date: date,
      Time: time,
      Method: method,
    }).then((response) => {
      setspeed(response.data.traffic.speed);
      setmindistance(response.data.traffic.min_distance);
      setavgdistance(response.data.traffic.avg_distance);
      setcongestion(response.data.traffic.congestion);
    });
  };
  return (
    <div>
      <input
        class="input1"
        type="date"
        // max={moment().format("YYYY-MM-DD")}
        min="2018-03-01"
        max="2018-03-04"
        value={date}
        onChange={(event) => {
          setdate(event.target.value);
        }}
      ></input>
      <input
        class="input2"
        type="time"
        step="3600"
        value={time}
        onChange={(event) => {
          settime(event.target.value);
        }}
      ></input>
      <select
        class="select2"
        onChange={(event) => {
          setmethod(event.target.value);
        }}
      >
        <option value="Kriging Interpolation">Kriging Interpolation</option>
        <option value="IDW Interpolation">IDW Interpolation</option>
        <option value="Nearest Neighbour">Nearest Neighbour</option>
        {/* <option value="Gaussian">Gaussian</option> */}
      </select>
      <img class="img1" src={imsc} alt="" />
      <Map
        initialViewState={{
          longitude: long,
          latitude: lat,
          zoom: 12,
        }}
        onClick={handleOnClick}
        style={{ width: "100vw", height: "100vh" }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        mapboxAccessToken="pk.eyJ1IjoiY2FuYXN0YXNpb3UiLCJhIjoiY2w0ZXowc2ZiMDc0bDNqbzFxZWp6M2ttciJ9.AlAcpimbT_J99eRS_dYKog"
      >
        <Marker longitude={long} latitude={lat}>
          <img src={markerUrl} alt="" height={"40px"} width={"40px"} />
        </Marker>
        <Popup
          longitude={long}
          latitude={lat}
          closeOnClick={false}
          anchor="left"
        >
          <div style={{ display: "inline" }}>
            <p class="h1">
              Latitude: <span class="value">{lat}</span>
            </p>
            <p class="h1">
              Longitude: <span class="value">{long}</span>
            </p>
            <p class="h1">
              Overall Congestion <span class="value">{congestion}</span>
            </p>
            <p class="h1">
              Estimated Speed: <span class="value">{speed} mph</span>
            </p>
            <p class="h1">
              Estimated Method: <span class="value">{method}</span>
            </p>
            <p class="h1">
              Number of sensors: <span class="value">10</span>
            </p>
            <p class="h1">
              Dist. to nearest sensor: <span class="value">{mindistance}</span>
            </p>
            <p class="h1">
              Avg. dist to sensors: <span class="value">{avgdistance}</span>
            </p>
          </div>
        </Popup>
        <NavigationControl />
      </Map>
    </div>
  );
}

export default TrafficIndexCoords;
